import React from 'react';

export enum MetaCategories {
    CWG = 'CWG',
    NFI = 'NFI',
    FSL = 'FSL',
}

export enum Categories {
    'CASH-MAG' = 'CASH-MAG',
}

export enum SupportedCountries {
    ukraine = 'ukraine',
    syr_gos = 'syr-gos',
}

export type CountrySpecificType<T = React.ReactNode> = {
    customPerCountry?: { [key in SupportedCountries]?: T };
};

export type CategoryAndCountrySpecificType<T = React.ReactNode> = {
    customPerCategoryAndCountry?: {
        [key in Categories]?: {
            [country in SupportedCountries]?: T;
        };
    };
};

export type MetaCategoryAndCountrySpecificType<T = React.ReactNode> = {
    customPerMetaCategoryAndCountry?: {
        [key in MetaCategories]?: {
            [country in SupportedCountries]?: T;
        };
    };
};

export type DefaultValueType<T = React.ReactNode> = {
    default: T;
};
